function toggleAccordion(header) {
    const item = header.parentElement;
    const panel = header.nextElementSibling;
    const isActive = item.classList.contains('active');

    if (!isActive) {
        item.classList.add('active');
        panel.style.maxHeight = panel.scrollHeight + "px";
    } else {
        item.classList.remove('active');
        panel.style.maxHeight = null;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const contentMain = document.querySelector('.faq-content');
    const faqLayout = document.querySelector('.faq-layout');
    const headerElement = document.querySelector('.shopify-section-header') || document.querySelector('header');


    const scrollToAnchor = (targetId, isSmooth = true) => {
        const targetElement = document.querySelector(targetId);
        if (!targetElement || !contentMain || !faqLayout) return;

        const behavior = isSmooth ? 'smooth' : 'auto';
        const headerHeight = headerElement ? headerElement.offsetHeight : 0;

        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            targetElement.scrollIntoView({
                behavior: behavior,
                block: 'start'
            });
        } else {
            const layoutTop = faqLayout.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
            window.scrollTo({
                top: layoutTop,
                behavior: behavior
            });
            const offsetPosition = targetElement.offsetTop;
            contentMain.scrollTo({
                top: offsetPosition,
                behavior: behavior
            });
        }
    };

    document.querySelectorAll('.faq-sidebar a').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href.startsWith('#')) {
                e.preventDefault();
                scrollToAnchor(href);
                history.pushState(null, null, href);
            }
        });
    });

    const handleInitialHash = () => {
        const hash = window.location.hash;
        if (!hash) return;
        let retryCount = 0;
        const scrollInterval = setInterval(() => {
            const targetElement = document.querySelector(hash);
            if (targetElement) {
                clearInterval(scrollInterval);
            
                setTimeout(() => {
                    window.scrollTo(0, 0); 
                    scrollToAnchor(hash, true);
                }, 100);
            }

            retryCount++;
            if (retryCount > 30) { 
                clearInterval(scrollInterval);
            }
        }, 100);
    };

    window.addEventListener('load', handleInitialHash);
    window.addEventListener('hashchange', handleInitialHash);

    contentMain.addEventListener('scroll', () => {
        let current = "";
        const sections = document.querySelectorAll('.faq-group');
        const scrollPosition = contentMain.scrollTop;

        sections.forEach(section => {
            if (scrollPosition >= section.offsetTop - 60) {
                current = section.getAttribute('id');
            }
        });

        document.querySelectorAll('.faq-sidebar li').forEach(li => {
            li.classList.remove('active');
            const anchor = li.querySelector('a');
            if (anchor) {
                const linkHash = anchor.getAttribute('href').replace('#', '');
                if (linkHash === current) {
                    li.classList.add('active');
                }
            }
        });
    });
});